"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../basics/Button/styles");
var Avatar_1 = __importDefault(require("../../misc/Avatar"));
var DropdownMenu_1 = __importDefault(require("../../misc/DropdownMenu"));
var typography_1 = require("../../typography");
var VerticalSpacer_1 = __importDefault(require("../../utils/VerticalSpacer"));
var IconButton_1 = __importDefault(require("../SiteHeader/components/IconButton"));
var AVATAR_SIZE = {
    small: styles_1.LEVEL_CONFIG['2'].small.height,
    medium: styles_1.LEVEL_CONFIG['2'].medium.height,
    large: styles_1.LEVEL_CONFIG['2'].large.height,
};
var UserDropdownMenu = function (_a) {
    var user = _a.user, items = _a.items, closeOn = _a.closeOn, size = _a.size;
    return (react_1.default.createElement(DropdownMenu_1.default, { zIndex: 1, anchor: function (_a) {
            var isOpen = _a.isOpen, props = __rest(_a, ["isOpen"]);
            return (react_1.default.createElement(IconButton_1.default, __assign({}, props, { icon: react_1.default.createElement(Avatar_1.default, { image: user.image, size: size || AVATAR_SIZE, backgroundColor: "WHITE" }), ariaLabel: isOpen ? 'Close user menu' : 'Open user menu' })));
        }, items: __spreadArray([
            {
                children: (react_1.default.createElement(VerticalSpacer_1.default, { amount: { small: 0, medium: 0, large: 0 } },
                    react_1.default.createElement(typography_1.Body, { level: "3" },
                        "Hello",
                        user.name ? ", " + user.name + "!" : ''),
                    react_1.default.createElement(typography_1.Body, { level: "3", color: "GREY_70" }, user.email))),
            }
        ], __read(items)), closeOn: closeOn, from: "right" }));
};
exports.default = UserDropdownMenu;
